<div class="sh-action-bar">
    <div class="sh-action-bar__group">
        <div class="sh-action-bar__group__item" *ngIf="totalResults !== null">
            <h5 class="sh-clear-margin" *ngIf="totalResults !== 0">
                {{ xxResultsLabelKey || "general.xx-results.other" | translate: { amount: totalResults } }}
            </h5>
            <h5 class="sh-clear-margin" *ngIf="totalResults === 0">{{ noResultsLabelKey || "general.no-results.other" | translate }}</h5>
        </div>
    </div>
    <div class="sh-action-bar__group -sh-condense">
        <ng-container *ngIf="showSortSelect && (displayMode$ | async) !== displayModes.MAP">
            <sh-sort-select
                class="sh-action-bar__group__item"
                *ngIf="sortInfo$ | async"
                [sortInfo]="sortInfo$ | async"
                [sortOptions]="sortOptions"
                (sortInfoChanged)="onSortInfoChanged($event)"
                [prefixMessage]="sortPrefixMessage"
                [loadingMsg]="sortLoadingMsg"
            ></sh-sort-select>
        </ng-container>
        <ng-container *ngIf="showViewToggle">
            <sh-view-toggle
                class="sh-action-bar__group__item"
                [displayMode]="displayMode$ | async"
                [displayOptions]="displayOptions"
                (displayModeChanged)="onViewModeSelected($event)"
            ></sh-view-toggle>
        </ng-container>
    </div>
</div>
